import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Wrapper } from "modules/theme";
import { Alert, confirm } from "modules/theme";
import { CenterFlexRow, BackButton } from "../../styles";
import APIManager from "modules/common/apiManager";
import SIPExtensionAddEdit from "./SIPExtensionAddEdit";
import { PerPage } from "helpers/system-config";
import {
  ModalTrigger,
  FormControl,
  ActionButtons,
  Table,
  DataWithLoader,
  ControlLabel,
  ReportPagination,
  SeachForm,
  ImportFile,
  DataWrapperClass,
  ButtonCommonTheme,
  SettingDropdownMenu,
  Icon,
} from "modules/theme";
import { injectGlobal } from "styled-components";
import { modalType } from "../../../../../helpers/dotenv";
import { OverflowClass } from "modules/theme";

injectGlobal`
  @media only screen and (max-width: 767px) {
    // .btn-back{
    //   display:block;
    // }
    // .header-label{
    //   margin-top:35%;
    // }
  }
`;

class SIPExtensions extends Component {
  constructor(props) {
    super(props);
    this.mAPI = new APIManager();
    this.moduleName = `SIP Extensions`;
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModalShow = this.closeModalShow.bind(this);
    this.onPaginationChange = this.onPaginationChange.bind(this);
    this.onPerPageChooser = this.onPerPageChooser.bind(this);
    this.handleModal = this.handleModal.bind(this);
    this.state = {
      listData: [],
      total: 0,
      currentPage: 1,
      perPageCount: PerPage,
      loading: false,
      editData: null,
      infoData: null,
      showHide: false,
      modalType: modalType,
      search: "",
      MasterChecked: false,
      SingleChecked: false,
      SelectedList: [],
      ary: [],
      show: false,
    };
  }

  handleModal() {
    this.setState({ show: !this.state.show });
  }

  onMasterCheck(e) {
    let tempList = this.state.listData;
    // Check/ UnCheck All Items
    tempList.map((listData) => (listData.selected = e.target.checked));
    //Update State
    this.setState({
      MasterChecked: e.target.checked,
      listData: tempList,
      SelectedList: this.state.listData.filter((e) => e.selected),
    });
  }

  onItemCheck(e, item) {
    let tempList = this.state.listData;
    tempList.map((user) => {
      if (user._id === item._id) {
        user.selected = e.target.checked;
      }
      return user;
    });
    const totalItems = this.state.listData.length;
    const totalCheckedItems = tempList.filter((e) => e.selected).length;
    this.setState({
      MasterChecked: totalItems === totalCheckedItems && e.target.checked,
      listData: tempList,
      SelectedList: this.state.listData.filter((e) => e.selected),
    });
  }

  deleteAllData(e) {
    let _this = this;
    e.preventDefault();
    const list = this.state.SelectedList.map((data) => {
      this.state.ary.push(data._id);
      console.log("data", this.state.ary);
    });
    this.mAPI.sendPostAPI(
      `setting/sip/multiple/usingIds`,
      {
        ids: this.state.ary,
      },
      (data) => {
        console.log(JSON.stringify(data, null, 2));
        this.setState({
          SelectedList: [],
          MasterChecked: false,
          SingleChecked: false,
        });
        this.getSIPExtensions(
          this.state.currentPage,
          this.state.perPageCount,
          this.state.search
        );
        Alert.success(`${this.moduleName} deleted successfully.`);
      },
      (errorCode, data) => {
        console.log(`Error: `, errorCode);
        console.log(`Data`, data);
        Alert.error(`errorCode : ${data}`);
      },
      `private`,
      {},
      "PUT"
    );
  }

  search(e) {
    let teamList = this.state.listData;
    teamList.map((e) => (e.selected = false));
    this.setState({
      SelectedList: [],
      MasterChecked: false,
      SingleChecked: false,
      listData: teamList,
      currentPage: 1
    });
    let value;
    value = e.target.value;
    const reg = /^[a-zA-Z0-9_ @]*$/;
    if (reg.test(value)) {
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.setState({ search: value });
        this.getSIPExtensions(1, this.state.perPageCount, value);
      }, 500);
    }
  }

  componentDidMount() {
    this.getSIPExtensions(
      this.state.currentPage,
      this.state.perPageCount,
      this.state.search
    );
  }

  getSIPExtensions(page = 1, perPage = "", searchText = "") {
    var that = this;
    this.setState({ loading: true });
    perPage = perPage || this.state.perPageCount;
    this.mAPI.sendGetAPI(
      `setting/sip?limit=${perPage}&page_no=${page}&orderBy=create_at&order=DESC&search=${searchText}`,
      (data) => {
        this.setState({ loading: false });
        console.log(JSON.stringify(data, null, 2));
        if (data && data.data) {
          that.setState({
            listData: data.data,
            total: data.count || 0,
            SelectedList: [],
            ary: [],
          });
        } else {
          that.setState({ listData: [] });
        }
      },
      (error, data) => {
        console.log(`Error:`, error);
      }
    );
  }

  onPaginationChange(page) {
    console.log("onPaginationChange", page);
    this.setState({ currentPage: page });
    this.getSIPExtensions(page, "", this.state.search);
  }

  onPerPageChooser(perPage) {
    console.log("onPerPageChooser", perPage);
    this.setState({ currentPage: 1 });
    this.setState({ perPageCount: perPage });
    this.getSIPExtensions(1, perPage, this.state.search);
  }

  closeModalShow() {
    this.setState({ show: false });
  }

  closeModal(isUpdated) {
    console.log("isUpdated", isUpdated);
    this.setState({ showHide: false });
    if (isUpdated) {
      this.getSIPExtensions(
        this.state.currentPage,
        this.state.perPageCount,
        this.state.search
      );
    }
  }
  openModal(data) {
    if (data) {
      this.setState({ showHide: true, infoData: data });
    } else {
      this.setState({ showHide: true, infoData: undefined });
    }
  }

  remove(array, key, value) {
    const index = array.findIndex((obj) => obj[key] === value);
    return index >= 0
      ? [...array.slice(0, index), ...array.slice(index + 1)]
      : array;
  }

  deleteSIPExtension(tSIPExtension) {
    var that = this;
    this.mAPI.sendPostAPI(
      `setting/sip/${tSIPExtension._id}`,
      undefined,
      (data) => {
        console.log(JSON.stringify(data, null, 2));
        let tD = that.state.listData;
        tD = that.remove(tD, "_id", tSIPExtension._id);
        that.setState({ listData: tD });
        that.getSIPExtensions(
          this.state.currentPage,
          this.state.perPageCount,
          this.state.search
        );
        Alert.success(
          // `The ${tSIPExtension.sip} is deleted.`
          `${this.moduleName} deleted successfully.`
        );
      },
      (errorCode, data) => {
        console.log(`Error: `, errorCode);
        console.log(`Data`, data);
        Alert.error(`errorCode : ${data.message}`);
      },
      "private",
      {},
      "DELETE"
    );
  }

  infoSIPExtension(tSIPExtension) {
    return (
      <ButtonCommonTheme
        type="infoBtn"
        infoOnClick={() => this.openModal(tSIPExtension)}
      />
    );
  }

  getIDDetails(tSIPExtension) {
    var that = this;
    this.setState({ loading: true });
    this.mAPI.sendGetAPI(
      `setting/sip/${tSIPExtension._id}`,
      (data) => {
        this.setState({ loading: false });
        console.log(JSON.stringify(data, null, 2));
        if (data) {
          console.log("Dataaaa", data);
          // that.setState({ listData: data.data, total: data.count || 0 });
        } else {
          // that.setState({ listData: [] });
        }
      },
      (error, data) => {
        console.log(`Error:`, error);
      }
    );
  }

  renderActions(tSIPExtension) {
    const { __ } = this.context;
    return (
      <ActionButtons>
        {this.infoSIPExtension(tSIPExtension)}
        <ButtonCommonTheme
          type="delete"
          deleteOnClick={(e) =>
            confirm().then((e) => {
              this.deleteSIPExtension(tSIPExtension, e);
            })
          }
        />
      </ActionButtons>
    );
  }

  importContact(file) {
    let formData = new FormData();
    formData.append("file", file);
    return formData;
  }

  renderActionBar() {
    let _this = this;
    const ImportTrigger = ({ onClick }) => {
      console.log("typeProps", onClick);
      return <ButtonCommonTheme type="add" addOnClick={onClick} />;
    };
    return (
      <span style={{ display: "flex", whiteSpace: "nowrap" }}>
        <ModalTrigger
          title="SIP Extension"
          trigger={<ImportTrigger />}
          size="md"
          showHide={this.state.showHide}
          closeModal={this.closeModal}
          openModal={this.openModal}
          openModalShow={this.openModalShow}
          dialogClassName={this.state.modalType}
        >
          <SIPExtensionAddEdit
            update={() => this.setState({ currentPage: 1 })}
            size="small"
            isEdit={false}
            infoData={this.state.infoData}
            closeModal={this.closeModal}
            modalType={this.state.modalType}
          />
        </ModalTrigger>

        <ImportFile
          apiUrl={`setting/sip/report/import`}
          fetchData={this.importContact}
          importDone={() => {
            console.log("done");
            _this.setState({ loading: true });
            setTimeout(() => {
              _this.onPerPageChooser(_this.state.perPageCount);
            }, 3000);
          }}
          urlDownload={`sip-extension.csv`}
        ></ImportFile>
      </span>
    );
  }

  render() {
    const { __ } = this.context;
    const breadcrumb = [
      { title: __("Settings"), link: "/settings" },
      { title: __("SIP Extensions"), link: "/settings/SIPExtensions" },
    ];

    const mainContent = (
      <DataWrapperClass overflow="auto" className="tableFixHeadSecondary">
        <OverflowClass style={{ overflow: "auto" }}>
          <Table whiteSpace="nowrap" bordered hover>
            <thead>
              <tr>
                <th onClick={this.onClick}>
                  <FormControl
                    componentClass="checkbox"
                    checked={this.state.MasterChecked}
                    onChange={(e) => this.onMasterCheck(e)}
                  />
                </th>
                <th>{__("SIP")}</th>
                <th>{__("TYPE")}</th>
                {/* <th>{__('ELEMENTS')}</th> */}
                <th>{__("Actions")}</th>
              </tr>
            </thead>
            <tbody id="SIPExtensions">
              {this.state.listData &&
                this.state.listData.map((tSIPExtension) => (
                  <tr key={tSIPExtension._id}>
                    <td onClick={this.onClick}>
                      <FormControl
                        componentClass="checkbox"
                        checked={tSIPExtension.selected}
                        onChange={(e) => this.onItemCheck(e, tSIPExtension)}
                      />
                    </td>
                    <td className="text-primary">{tSIPExtension.sip}</td>
                    <td>{tSIPExtension.type}</td>
                    {/* <td>
                    {tSIPExtension.elements}
                  </td> */}
                    <td>{this.renderActions(tSIPExtension)}</td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </OverflowClass>
      </DataWrapperClass>
    );

    return (
      <div className="heightClass">
        <DataWrapperClass>
          <Wrapper
            header={<Wrapper.Header breadcrumb={breadcrumb} />}
            heading={
              <CenterFlexRow className="header-label">
                <Link className="btn-back" to={`/settings`}>
                  <BackButton>
                    <Icon icon="angle-left" size={20} />
                  </BackButton>
                </Link>
                <ControlLabel>{`SIP Extensions`}</ControlLabel>
              </CenterFlexRow>
            }
            actionBar={
              <Wrapper.ActionBar
                left={
                  <div style={{ display: "flex" }}>
                    <SeachForm className="mr-3">
                      <FormControl
                        type="text"
                        placeholder={"Search..."}
                        onChange={(e) => this.search(e)}
                        value={this.state.searchValue}
                        autoFocus={false}
                      />
                      <span class="material-symbols-outlined">search</span>
                    </SeachForm>
                    {this.state.SelectedList.length > 0 ? (
                      <ButtonCommonTheme
                        type="deleteAll"
                        checkboxDeleteOnClick={(e) =>
                          confirm().then((e) => {
                            this.deleteAllData(e);
                          })
                        }
                      />
                    ) : (
                      ""
                    )}
                  </div>
                }
                // right={actionBarRight}
                right={this.renderActionBar()}
              />
            }
            footer={
              <ReportPagination
                count={this.state.total}
                onPaginationChange={this.onPaginationChange}
                onPerPageChooser={this.onPerPageChooser}
                currentPage={this.state.currentPage}
                perPage={this.state.perPageCount}
              />
            }
            leftSidebar={<SettingDropdownMenu />}
            showLeftSideBar={true}
            content={
              <div>
                <DataWithLoader
                  data={mainContent}
                  loading={this.state.loading}
                  size={this.state.listData.length}
                  count={this.state.listData.length}
                  emptyText=""
                  emptyImage="/images/emptySIP.png"
                />
              </div>
            }
          />
        </DataWrapperClass>
      </div>
    );
  }
}

SIPExtensions.contextTypes = {
  __: PropTypes.func,
};

export default SIPExtensions;



// WEBPACK FOOTER //
// src/modules/screens/settings/SIPExtensions/components/SIPExtensions.js